export default [{
  path: '/view/relatorio-checklist/:id',
  name: 'relatoriochecklist',
  component: () => import('@/shared/components/relatorio-checklist/RelatorioCheckList.vue'),
  meta: {
    requiredAuth: false,
    action: 'auditar',
    layout: 'full',
  },
}]
